import { Link } from "react-router-dom";
import { t } from "ttag";

import { ADMIN_ROUTES } from "@/app/router";
import { LogoLoader } from "@/shared/components";
import {
  Button,
  CheckCircleIcon,
  DisketteIcon,
  TrashBinIcon,
} from "@/shared/ui";
import { handleAxiosFieldErrors } from "@/shared/utils";
import { useCreateSessionContext } from "../context";
import { useCreateSession } from "../hooks";
import type { ActionsVariants } from "./utils";
import { actionsVariants } from "./utils";

export const CreateSessionActions = ({ position }: ActionsVariants) => {
  const { container } = actionsVariants({ position });

  const {
    sessionForm: {
      formState: { dirtyFields },
      handleSubmit,
      setError,
    },
  } = useCreateSessionContext();

  const createSessionMutation = useCreateSession(setError);

  const handleSaveDraft = handleSubmit((value) =>
    createSessionMutation.mutate({ ...value, published: false }),
  );

  const handlePublish = handleSubmit((value) =>
    createSessionMutation.mutate(
      { ...value, published: true },
      { onError: (error) => handleAxiosFieldErrors(error, setError) },
    ),
  );

  const isDirty = Object.keys(dirtyFields).length > 0;

  return (
    <div className={container()}>
      <Button
        asChild
        size="lg"
        variant="tertiary"
        className="px-2 text-red-800 hover:text-red-700"
      >
        <Link to={ADMIN_ROUTES.COACHING.BASE}>
          <TrashBinIcon className="size-4" />
          {t`Discard`}
        </Link>
      </Button>

      <Button
        onClick={handleSaveDraft}
        disabled={!isDirty}
        variant="secondary"
        size="lg"
      >
        <DisketteIcon className="size-4" />
        {t`Save as draft`}
      </Button>

      <Button onClick={handlePublish} disabled={!isDirty} size="lg">
        <CheckCircleIcon className="size-4" />
        {t`Publish`}
      </Button>

      <LogoLoader show={createSessionMutation.isPending} fullscreen />
    </div>
  );
};
